import { render, staticRenderFns } from "./FormSendMessage.vue?vue&type=template&id=beb24c10"
import script from "./FormSendMessage.vue?vue&type=script&lang=js"
export * from "./FormSendMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports